import React, { useState, useEffect } from 'react';

import { Card, CardContent, CardHeader, Skeleton } from '@mui/material';

import ChartIcon from '@mui/icons-material/InsertChart';

import { ResponsiveBump } from '@nivo/bump'

import {
  OffCanvas,
  useMessageDispatch,
} from 'itaf';

import AccessService from '../../../services/AccessService';

export default function AccessChartCanvas({ open, onCanvasClose }) {
  const [dataChart, setDataChart] = useState([]);
  const [isLoading, setLoading] = useState(false);
  const [progress, setProgress] = React.useState(0);
  const title = 'Gráfico de acessos dos ususário';

  const setMessageLocal = useMessageDispatch();
  function setMessage(message) {
    if ('parentIFrame' in window) {
      window.parentIFrame.sendMessage(message);
    }
  
    setMessageLocal(message);
  }

  useEffect(() => {
    if (open) {
      loadChart();
    }
  }, [open]);

  function loadChart() {
    setLoading(true);
    AccessService.getAccessChart()
      .then((response) => {
        setProgress(100);
        if (response.ok) {
          return response.json();
        }
        else {
          setMessage({ hasError: true, text: "Problema ao carregar gráfico. Verifique conexão de internet." });
          return null;
        }
      })
      .then((result) => {
        if (result === null) {
          return;
        }
        var data = [];
        result.map((item) => { data.push({ ...item, data: JSON.parse(item.data) })})
        setDataChart(data);
      })
      .catch ((error) => {
        console.log(error)
        setMessage({ hasError: true, text: "Problema ao carregar gráfico. Tente atualizar a tela." });
      })
      .finally (() => {
        setLoading(false);
        setProgress(0);
      });
  }
  
  const handleDrawerClose = () => {
    // setTimeout(() => { setMessage({ hasError: false, text: '' }); }, 10000);
    onCanvasClose(false);
  };

  const tooltip = ({ point }) => {
    const date = new Date(point?.data?.x);
    const valueX = date.toLocaleDateString('pt-BR');
    const valueY = point?.data?.y || 0;
    return (
    <div style={{
      // background: 'white', 
      // color: 'inherit',
      background: point.serie.color,
      color: 'white',
      fontWeight: 'bold',
      fontSize: 'inherit',
      borderRadius: '2px', 
      boxShadow: 'rgba(0, 0, 0, 0.25) 0px 1px 2px',
      padding: '5px 9px',
      display: 'max-content',
      whiteSpace: 'pre',
    }}>
      Nome: {point?.serie?.id}
      <br />
      Data:{valueX}
      <br />
      Acessos: ({Math.abs(valueY)})
    </div>
  )};

  return (
    <OffCanvas
      widthLg
      closeLabel="Fechar"
      showPanel={open}
      onClosedPanel={handleDrawerClose}
      isLoading={isLoading}
      header={{ title: title, add: false, edit: false, icon: (<ChartIcon />) }}
      progress={progress}
    >
        {isLoading && <Skeleton variant="rounded" width={'100%'} height={`calc(100vh - 192px)`} />}
        {!isLoading && 
          <Card sx={{ padding: 1 }}>
            <CardHeader title={'Acessos dos usários nos últimos 15 dias'} sx={{ padding: 1 }}/>
            <CardContent sx={{ width: '100%', height: `calc(100vh - 216px)` }}>
              <ResponsiveBump
                data={dataChart}
                activeLineWidth={6}
                activePointBorderWidth={3}
                activePointSize={16}
                animate={true}
                enableSlices='x'
                colors={{ scheme: 'category10' }}
                lineWidth={3}
                inactiveLineWidth={3}
                inactiveOpacity={0.15}
                inactivePointSize={0}
                margin={{ top: 0, right: 88, bottom: 56, left: 48 }}
                pointBorderColor={{ from: 'serie.color' }}
                pointBorderWidth={3}
                pointColor={{ theme: 'background' }}
                pointSize={10}
                axisTop={null}
                axisBottom={{
                  orient: 'bottom',
                  format: function(value) {
                    var date = new Date(value);
                    return date.toLocaleDateString('pt-BR');
                  },
                  tickSize: 10,
                  tickPadding: 5,
                  legend: 'Data',
                  legendPosition: 'middle',
                  legendOffset: 40,
                }}
                axisLeft={{
                  tickSize: 5,
                  tickPadding: 5,
                  tickRotation: 0,
                  legend: 'Acessos',
                  legendPosition: 'middle',
                  legendOffset: -40, 
                  truncateTickAt: 0,
                  format: (v) => (v * -1),

                }}
                axisRight={null}
                pointTooltip={tooltip}
                useMesh={true}
              />
            </CardContent>
          </Card>}
    </OffCanvas>
  );
};
